
/* injects from baggage-loader */

'use strict';

export default class ProjectDonationWizardStep2Controller {

	constructor($log, $state, $scope, $document, $timeout, Parse, Alerts, User, stripe) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$scope = $scope;
		this.$document = $document;
		this.$timeout = $timeout;
		this.Alerts = Alerts;
		this.stripe = stripe;

		this.Parse = Parse;

		this.new_card = {};

		// Set the default payment option
		this.payment_option = 'card';

		// Hold existing payment methods
		this.bank_accounts = [];
		this.cards = [];

		// Flags to enable new source forms, false by default
		this.isAddingCard = false;
		this.isAddingBankAccount = false;

		this.isRegisteredUser = User.isUserLoggedIn();
		this.$log.log('Anonymous User:', !this.isRegisteredUser)

	}

	$onInit() {
		this.$log.log(this.donation);

		// Assign existing payment sources
		if (this.stripeAccount && this.stripeAccount.sources && this.stripeAccount.sources.data) {
			for (let source of this.stripeAccount.sources.data) {
				if (source.object === 'card') {
					this.cards.push(source);
				} else if (source.object === 'bank_account') {
					this.bank_accounts.push(source);
				} else {
					/* do nothing */
				}
			}
		}

		// Show add card form if no cards present
		if (!this.cards.length) {
			this.isAddingCard = true;
		}

		// this.$log.log('Bank Accounts:', this.bank_accounts);
		// this.$log.log('Cards:', this.cards)

		// Listen for events when a card is added
		this.$scope.$on('accountSettings.newCard', (event, card) => {

			// Set the new card as the source id
			this.donation.source_id = card.id;
			card.selected = true;

			// Push the new card to cards
			this.cards.push(card);

			// Close the card form
			this.isAddingCard = false;

			// Scroll to the top of the page
			this.$document.scrollTopAnimated(0);

		});

		// Listen for events to close the card form
		this.$scope.$on('accountSettings.closeAddCardForm', event => {

			// Close the card form
			this.isAddingCard = false;

			// Scroll to the top of the page
			// this.$document.scrollTopAnimated(0);

		});

	}


	/**
	 * Select the payment option
	 * @param {String} option 
	 */
	setPaymentOption(option) {

		// Check if we have registered user
		if (!this.isRegisteredUser) {
			return false;
		}

		// Make sure to clear the selected payment source if the option changes and close the forms
		if (option !== this.payment_option) {
			this.unselectAllSources();
			this.isAddingCard = false;
			this.isAddingBankAccount = false;
		}

		// Set the payment option
		this.payment_option = option;

		// Show add card form if no cards present
		if (option === 'card' && !this.cards.length) {
			this.isAddingCard = true;
		}

	}


	/**
	 * Select a source to use as the form of payment
	 * @param {Object} source 
	 */
	selectPaymentSource(source) {

		// Unselect all the other payment sources
		this.unselectAllSources();

		// Set the current source selected
		source.selected = true;
		this.donation.source_id = source.id;

	}


	/**
	 * Unselect all payment methods
	 */
	unselectAllSources() {
		this.donation.source_id = '';
		for (let card of this.cards) {
			card.selected = false;
		}
		for (let account of this.bank_accounts) {
			account.selected = false;
		}
	}


	addNewCard() {
		this.isAddingCard = true;
	}


	/**
	 * Make donation
	 */
	makeDonation() {

		this.$log.log(this.donation);
		this.makingDonation = true;

		// Call the cloud code fn to connect the user
		this.Parse.Cloud.run('processDonation', this.donation)
			.then(donation => {
				// this.$log.log(donation);
				// this.makingDonation = false;

				// Go to the donation confirmation page
				this.$state.go('donation-confirmation');

			})
			.catch(err => {
				this.$log.error(err);
				this.Alerts.setLocal({
					msg: err,
					type: 'danger'
				});
				this.makingDonation = false;
				this.$timeout();
			});

	}


	/**
	 * Retuns true if all required card info has been entered
	 */
	cardInfoValid() {
		return ['number', 'name', 'expiry', 'cvc'].reduce((pass, field) => {
			if (pass && this.new_card[field]) return true;
			else return false;
		}, true);
	}


	/**
	 * Make a donation as an unregistered user with card info that must be tokenized before use
	 */
	async makeDonationWithNewCard() {

		// this.$log.log(this.donation);

		this.makingDonation = true;

		// Generate a token from the card info
		let token = await this.stripe.card.createToken({
			number: this.new_card.number,
			exp_month: this.new_card.expiry.split('/')[0],
			exp_year: this.new_card.expiry.split('/')[1],
			cvc: this.new_card.cvc
		});
		// this.$log.log(token);

		// Set the donation source as the new card token
		this.donation.source_id = token.id;

		// Call the cloud code fn to connect the user
		this.Parse.Cloud.run('processDonation', this.donation)
			.then(donation => {
				// this.$log.log(donation);
				// this.makingDonation = false;

				// Go to the donation confirmation page
				this.$state.go('donation-confirmation');

			})
			.catch(err => {
				this.$log.error(err);
				this.Alerts.setLocal({
					msg: err,
					type: 'danger'
				});
				this.makingDonation = false;
				this.$timeout();
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step2/project-donation-wizard.step2.controller.js